import { AxiosRequestConfig } from 'axios'

const fulfilled = async (config: AxiosRequestConfig) => {
  return config
}
const rejected = (error: unknown) => {
  // do something with request error
  console.log(error) // for debug
  return Promise.reject(error)
}

export default {
  fulfilled,
  rejected
}
